import { Box } from '@palmetto/palmetto-components';
import { format } from 'date-fns';

import EventBy from './EventBy';

const VerificationDaysCalculated = ({ event }: { event: any }) => {
  const verificationDate = event?.data?.verificationDate
    ? format(new Date(event.data.verificationDate), 'MMM d, yyyy')
    : 'N/A';

  const verificationDays = event?.data?.verificationDays;
  const triggerEvent = event?.data?.triggerEvent;

  return (
    <Box display="block">
      <Box as="span" display="inline-block" margin="0 2xs 0 0">
        <EventBy event={event} />
        <span> Verification days calculated: </span>
        <strong>{verificationDays} days</strong>
        {triggerEvent && (
          <>
            <span> (triggered by </span>
            <strong>{triggerEvent}</strong>
            <span>)</span>
          </>
        )}
        <span>. Verification date set to </span>
        <strong>{verificationDate}</strong>
      </Box>
    </Box>
  );
};

export default VerificationDaysCalculated;
